import { Button, Dropdown, Icon, Menu, Tooltip } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import styles from './OpenFilterNewWithActions.module.scss';
import { ResetFilter } from '../../../../features/filterNew/reset';
import { OpenFilter } from '../../../../features/filterNew/open';
import { selectChosenFilterName } from '../../../../features/filterNew/model/selectors';

export const FILTER_NAME_VISIBLE_LENGTH = 25;

export const shortFilterName = (name) => {
  return name.length > FILTER_NAME_VISIBLE_LENGTH
    ? `${name.slice(0, FILTER_NAME_VISIBLE_LENGTH).trim()}...`
    : name;
};

const OverlayActions = (props) => {
  return (
    <Menu {...props}>
      <ResetFilter
        render={({ reset, ...props }) => (
          <Menu.Item
            {...props}
            onClick={reset}
          >
            <Icon
              type="sync"
              className={styles.icon}
            />
            Сбросить
          </Menu.Item>
        )}
      />
    </Menu>
  );
};

const OpenFilterNewWithActions = () => {
  const chosenFilterName = useSelector(selectChosenFilterName);

  return (
    <Dropdown
      overlay={<OverlayActions />}
      placement="bottomLeft"
    >
      <OpenFilter
        render={({ openFilter, ...props }) => (
          <Tooltip
            title="Фильтр"
            placement="topRight"
          >
            <Button
              {...props}
              icon="filter"
              onClick={openFilter}
            >
              {chosenFilterName && (
                <span style={{ marginLeft: 10 }}>
                  {shortFilterName(chosenFilterName)}
                </span>
              )}
            </Button>
          </Tooltip>
        )}
      />
    </Dropdown>
  );
};

export default OpenFilterNewWithActions;
